import { isProd } from './variables';

const staging = {
    api: 'https://api.waverez.com/v1-staging',
    apiTS: 'https://api.tripshock.com/dev_v1',
    content: 'https://api.tripshock.com/content-staging',
    redirects: 'https://staging-redirects.tripshock.com',
    affiliates: 'https://api.tripshock.com/affiliates-staging',
    image: 'https://staging-images.tripshock.com',
    apiImage: 'https://api.tripshock.com/image-staging',
    partners: 'https://partners.tripshock.com',
    iterable: 'https://api.iterable.com/api/',
    domain: 'https://reservations-staging.waverez.com/',
    crs: 'https://api.waverez.com/wr-crs-staging',
    megacache: 'https://api.waverez.com/megacache-staging/get',
};

const production = {
    api: 'https://api.waverez.com/v1',
    apiTS: 'https://api.tripshock.com/v1',
    content: 'https://api.tripshock.com/content',
    redirects: 'https://redirects.tripshock.com',
    affiliates: 'https://api.tripshock.com/affiliates',
    image: 'https://images.tripshock.com',
    apiImage: 'https://api.tripshock.com/image',
    partners: 'https://partners.tripshock.com',
    iterable: 'https://api.iterable.com/api/',
    domain: 'https://reservations.waverez.com/',
    crs: 'https://api.waverez.com/wr-crs',
    megacache: 'https://api.waverez.com/megacache/get',
};

export const URLs = !isProd ? staging : production;

export const ApiUrls = {
    activity: {
        root: '/activity',
        availability: {
            root: '/activity/availability',
            short: '/activity/availability/short',
            month: '/activity/availability/month',
        },
    },
    activities: {
        root: '/activities',
    },
    availability: {
        root: '/availability',
        month: '/availability/month',
        day: {
            root: '/availability/day',
            full: '/availability/day/full',
        },
    },
    categories: {
        root: '/get_categories',
    },
    routes: {
        root: '/routes',
    },
    partner: {
        root: '/partner',
    },
    photo: {
        root: '/photo',
        rootAll: '/photo/all',
        excerpt: '/photo/excerpt',
        excerptAll: '/photo/excerpt/all',
        dummy: 'https://reservations.waverez.com/assets/img/waverez/dummy-image.png',
    },
    video: {
        root: 'https://www.youtube.com/embed',
    },
    cart: {
        root: '/cart',
        add: '/add_cart',
        ext: '/ext_cart',
        del: '/del_cart',
        promo: {
            root: '/code',
            add: '/add_code',
            del: '/del_code',
        },
    },
    reviews: {
        root: '/reviews',
    },
    review: {
        list: '/review/list',
    },
    order: {
        root: '/order',
    },
    voucher: {
        root: '/voucher',
    },
    create_booking: {
        root: '/create_booking',
    },
    create_stripe_payment: {
        root: '/create_stripe_payment',
    },
    tips: {
        root: '/tips',
    },
    prices: {
        root: '/min_prices',
    },
    texts: {
        root: '/texts',
    },
    endpoint: {
        root: '/endpoint',
    },
};
